import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMask from 'v-mask';
import VueRouter from 'vue-router';
import vco from "v-click-outside";
import router from './router/index';
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueElementLoading from 'vue-element-loading';
import VueProgressiveImage from 'vue-progressive-image';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

if(process.env.NODE_ENV === 'development')
  import('@/design/index.scss').then(() => {
    console.log();
  });

import store from '@/state/store';

import App from './App.vue';

import i18n from './i18n';

import tinymce from 'vue-tinymce-editor';
Vue.component('tinymce', tinymce);

Vue.use(VueProgressiveImage);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);
Vue.config.productionTip = false;

Vue.component('VueElementLoading', VueElementLoading);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require('vue-chartist'));
Vue.use(VueSweetalert2);
Vue.use(require('vue-moment'));
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts);
Vue.component('Loader', require('./components/Loader.vue').default);
Vue.component('Emoji', require('./components/Emoji.vue').default);
Vue.component('ServerGroup', require('./components/teamspeak/ServerGroup.vue').default);
Vue.component('ServerGroups', require('./components/teamspeak/ServerGroups.vue').default);
Vue.component('Channel', require('./components/teamspeak/Channel.vue').default);
Vue.component('SelectClient', require('./components/teamspeak/SelectClient.vue').default);
Vue.component('Client', require('./components/teamspeak/Client.vue').default);
Vue.component('SelectServerGroups', require('./components/teamspeak/SelectServerGroups.vue').default);
Vue.component('SearchClient', require('./components/teamspeak/SearchClient.vue').default);
Vue.component('SuccessAnimation', require('./components/teamspeak/SuccessAnimation.vue').default);
Vue.component('DataTable', require('./components/DataTable.vue').default);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
